"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const intl_1 = require("@kyruus/intl");
const filters_1 = require("./lib/constants/filters");
const messages_1 = __importDefault(require("../common/util/constants/messages"));
const utils_1 = require("./lib/utils");
const ProviderInfo_1 = __importDefault(require("./ProviderInfo"));
const SchedulingHelpBanner_1 = __importDefault(require("./SchedulingHelpBanner"));
const TitledRow_1 = __importDefault(require("./TitledRow"));
const UntitledRow_1 = __importDefault(require("./UntitledRow"));
const styles_1 = require("./styles");
/**
 * Gets the formatted string for the corresponding patient relationship type
 * @param appointmentQuery {AppointmentQuery} The appointment query object to retrieve the patient relationship from.
 * @param intl {IntlShape} The intl object provided by injectIntl
 *                         We're using such an old intl version that the types are messed up, which is why it's set to any
 * @returns The formatted string, null if it can't process the MessageDescriptor, or void if the patientRel is unrecognized.
 */
const getPatientRelFromApptQuery = (appointmentQuery, intl) => {
    if ((appointmentQuery === null || appointmentQuery === void 0 ? void 0 : appointmentQuery.patientRel) === filters_1.NEW_PATIENT) {
        return intl.formatMessage(messages_1.default.newPatient);
    }
    else if ((appointmentQuery === null || appointmentQuery === void 0 ? void 0 : appointmentQuery.patientRel) === filters_1.ESTABLISHED_PATIENT) {
        return intl.formatMessage(messages_1.default.establishedPatient);
    }
};
const ProviderSidebar = ({ appointmentQuery, children, intl, locations, provider, selectedAppointment, showApptTime = true, showSchedulingHelpBanner = true, selectedLocation }) => {
    var _a, _b, _c, _d;
    const [ariaDescribedByIds, setAriaDescribedByIds] = (0, react_1.useState)([]);
    // Adding aria labelled by support for grouping elements
    // passed as children to the ProviderSidebar
    // To use this feature, the children should have an id prop
    (0, react_1.useEffect)(() => {
        const ariaIds = [
            'appointment-purpose',
            'provider-details',
            'appointment-time'
        ];
        react_1.default.Children.map(children, (child) => {
            if (react_1.default.isValidElement(child) && child.props.id) {
                ariaIds.push(child.props.id);
            }
        });
        setAriaDescribedByIds(ariaIds);
    }, [children]);
    if (!provider) {
        return null;
    }
    const isValidAppointmentQuery = appointmentQuery && appointmentQuery.patientRel && appointmentQuery.purpose;
    const location = (0, utils_1.getLocation)(selectedAppointment, locations, selectedLocation);
    const appointmentDate = selectedAppointment
        ? (0, utils_1.getAppointmentDate)(selectedAppointment)
        : {};
    const phone = (0, utils_1.getMainContactNumber)(provider, locations, selectedAppointment);
    return (react_1.default.createElement(styles_1.Container, { "data-testid": "Sidebar" },
        react_1.default.createElement(styles_1.Content, null,
            react_1.default.createElement(styles_1.Summary, { "data-testid": "Summary", "aria-labelledby": "provider-name", "aria-describedby": ariaDescribedByIds.join(' ') },
                react_1.default.createElement(ProviderInfo_1.default, { providerImg: (0, utils_1.getProviderImageUrl)(provider), providerName: (0, utils_1.formatProviderName)(provider), providerSpecialties: (0, utils_1.formatProviderSpecialties)(provider.specialties) }),
                isValidAppointmentQuery && (react_1.default.createElement(TitledRow_1.default, { id: "appointment-purpose", "data-testid": "Summary__ApptPurpose", title: react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default.appointmentDetails)), lineOne: getPatientRelFromApptQuery(appointmentQuery, intl), lineTwo: (_a = appointmentQuery === null || appointmentQuery === void 0 ? void 0 : appointmentQuery.purpose) === null || _a === void 0 ? void 0 : _a.name })),
                isValidAppointmentQuery &&
                    (0, utils_1.hasAnyVideoPhoneAppt)((_b = appointmentQuery === null || appointmentQuery === void 0 ? void 0 : appointmentQuery.purpose) === null || _b === void 0 ? void 0 : _b.visit_method) && (react_1.default.createElement(TitledRow_1.default, { "data-testid": "Summary__ApptType", title: react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default[(0, utils_1.getVisitTypeTitle)((_c = appointmentQuery === null || appointmentQuery === void 0 ? void 0 : appointmentQuery.purpose) === null || _c === void 0 ? void 0 : _c.visit_method)])) })),
                location &&
                    !(0, utils_1.hasAnyVideoPhoneAppt)((_d = appointmentQuery === null || appointmentQuery === void 0 ? void 0 : appointmentQuery.purpose) === null || _d === void 0 ? void 0 : _d.visit_method) && (react_1.default.createElement(TitledRow_1.default, { "data-testid": "Summary__ApptLocation", id: "provider-details", title: location.name, lineOne: (0, utils_1.formatLocation)(location) })),
                showApptTime && selectedAppointment && (react_1.default.createElement(UntitledRow_1.default, { id: "appointment-time", "data-testid": "Summary__ApptTime", lineOne: appointmentDate.formattedDate, lineTwo: appointmentDate.formattedTime })),
                children && react_1.default.createElement("div", null, children)),
            showSchedulingHelpBanner && react_1.default.createElement(SchedulingHelpBanner_1.default, { phone: phone }))));
};
exports.default = (0, intl_1.injectIntl)(ProviderSidebar);
//# sourceMappingURL=ProviderSidebar.js.map